export const profile = {
    text1: "معلومات حسابي",
    text2: "المعلومات الشخصية",
    text3: "الاسم",
    text4: "رقم الهوية",
    text5: "الهاتف",
    text6: "الدولة",
    text7: "عنوان البريد الإلكتروني",
    text8: "تحديث المعلومات",
    text9: "بيانات الدخول",
    text10: "كلمة المرور",
    text11: "تأكيد كلمة المرور",
    text12: "تحديث كلمة المرور",

    // Corrections
    p1: "إعدادات الحساب",
    p2: "بيانات الملف الشخصي",
    p3: "تسجيل الدخول والأمان",
    p4: "بيانات الفوترة",
    p5: "عنوان البريد الإلكتروني الأساسي",
    p6: "هنا ستصلك جميع رسائل WACheckin",
    p7: "معلومات الحساب",
    p8: "أدِر بيانات حسابك.",
    p9: "الاسم",
    p10: "أدخِل الاسم الكامل",
    p11: "رقم الهوية",
    p12: "أدخِل رقم الهوية",
    p13: "الهاتف",
    p14: "أدخِل رقم الهاتف",
    p15: "تسجيل الدخول والأمان",
    p16: "حدّث كلمة المرور وأمّن حسابك.",
    p17: "كلمة مرور الحساب",
    p18: "آخر تحديث:",
    p19: "تغيير كلمة المرور",
    p20: "بيانات الفوترة",
    p21: "أدِر بيانات حسابك.",
    p22: "اسم الشركة",
    p23: "أدخِل اسم الشركة",
    p24: "الرقم الضريبي",
    p25: "أدخِل الرقم الضريبي",
    p26: "عنوان الفوترة",
    p27: "أدخِل عنوان الفوترة",
    p28: "الدولة",
    p29: "المقاطعة",
    p30:'الرمز البريدي',
    p31:`لا توجد بيانات فوترة`,
    p32:`تُضاف بيانات الفوترة تلقائيًا عند الاشتراك.`,
};
